import { PlycaDataService } from '../../services/plyca.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Configuration } from '../conf/app.constants';
import { PropertyDTO } from '../api/plyca-dtos';
import { map } from 'rxjs/operators';
import { PaginationDTO } from '../api/PaginationModel';
import { tap } from 'rxjs/operators';


const empty_value = '#EMPTY#';

@Injectable()
export class PropertyService {

  private properties = new Map<string, string>();

  constructor(private plycaService: PlycaDataService, private configuration: Configuration) {
  }

  public init(): Observable<PaginationDTO<PropertyDTO>> {
    return this.plycaService
      .query<PropertyDTO>(this.configuration.PROPERTY_SERVICE_URL)
      .pipe(
        tap((resp: PaginationDTO<PropertyDTO>) => {
          if (resp && resp.content) {
            resp.content.forEach((property: PropertyDTO) => {
              let propertyValue = property.value;
              if (!propertyValue) {
                this.properties.set(property.identifier, empty_value);
              } else {
                this.properties.set(property.identifier, propertyValue);
                if (property.identifier === 'SERVIDOR_SERVAUX_AUTOFIRMA' && property.value) {
                  this.configuration.URL_BASE_AFIRMA = window.location.protocol + '//' + property.value + '/'
                    + this.configuration.plycaJ2EE_CONTEXT + 'afirma';
                  console.log('Actualizando valor URL de despliegue de servicios auxiliares de @Firma a '
                    , this.configuration.URL_BASE_AFIRMA);
                }
              }
            });
          }
        }
        )
      );

  }


  public getProperty(key: string, defaultValue?: string): Observable<string> {
    let value = this.properties.get(key);
    if (value === undefined) {
      return this.plycaService.get<PropertyDTO>(this.configuration.PROPERTY_SERVICE_URL, key).pipe(
        map((property: PropertyDTO) => {
          let propertyValue: string;
          if (!property || !property.value) {
            this.properties.set(key, empty_value);
            propertyValue = (defaultValue) ? defaultValue : undefined;
          } else {
            propertyValue = property.value;
            this.properties.set(key, propertyValue);
          }
          return propertyValue;
        })
      );
    } else if (value === empty_value) {
      return of((defaultValue) ? defaultValue : undefined);
    } else {
      return of(value);
    }
  }

  public instant(key: string, defaultValue?: string): string {
    let value = this.properties.get(key);
    if (value === undefined || value === empty_value) {
      return defaultValue;
    }
    return value;
  }

  public renew(): Observable<PaginationDTO<PropertyDTO>> {
    this.clear();
    return this.init();
  }

  public clear(): void {
    this.properties.clear();
  }

}
